import { render, staticRenderFns } from "./CreateSensor.vue?vue&type=template&id=d890d696&"
import script from "./CreateSensor.vue?vue&type=script&lang=js&"
export * from "./CreateSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports